// Module
var code = `<table class="table">
    <tr>
      <th></th>
      <th></th>
      <th class="custom-payment-cell"
          ng-if="\$ctrl.customPaymentAllowed">
        <div class="switch">
          <input class="no-print"
                 id="custom-payment"
                 type="checkbox"
                 ng-model="\$ctrl.customPayment"
                 ng-change="\$ctrl.onCustomPaymentChange()"/>
          <label class="no-print"
                 for="custom-payment">
            Custom payment
          </label>
        </div>
      </th>
    </tr>
    <tbody ng-if="!\$ctrl.customPayment">
    <!-- REGULAR PAYMENT -->
    <tr>
      <td>&nbsp;</td>
      <td>Amount:</td>
      <td>
        <cash ng-model="\$ctrl.paymentRequest.amount"
              ng-change="\$ctrl.calculatePreview()"
              ng-required="true"></cash>
      </td>
    </tr>
    </tbody>
    <tbody ng-if="\$ctrl.customPayment && \$ctrl.customPaymentAllowed">
    <!-- CUSTOM PAYMENT -->
    <tr ng-repeat="part in \$ctrl.customPaymentPartArray">
      <td>&nbsp;</td>
      <td>{{part.label}}:</td>
      <td class="custom-payment-amount-input">
        <cash ng-model="\$ctrl.paymentRequest[part.property]"
              max="\$ctrl.calculatePartTotal(part.property)"
              ng-change="\$ctrl.calculateTotalCustomPayment()"></cash>
        <span class="max no-print">Max. {{\$ctrl.calculatePartTotal(part.property) | nxCurrency}}</span>
      </td>
    </tr>
    <tr>
      <td>&nbsp;</td>
      <td>Total amount:</td>
      <td>
        <cash ng-model="\$ctrl.paymentRequest.amount"
              ng-disabled="true"
              min="0.01"></cash>
      </td>
    </tr>
    </tbody>
    <tbody>
    <tr ng-if="\$ctrl.collectTemporaryReceipt">
      <td>&nbsp;</td>
      <td>Temporary Invoice:</td>
      <td>
        <input type="text"
               ng-model="\$ctrl.paymentRequest.temporaryReceipt"
               ng-required="false">
      </td>
    </tr>
    <tr ng-if="\$ctrl.collectOfficialReceipt">
      <td>&nbsp;</td>
      <td>Invoice:</td>
      <td>
        <input type="text"
               ng-model="\$ctrl.paymentRequest.officialReceipt"
               ng-disabled="\$ctrl.autoReceiptEnabled"
               required>
        <div class="alert-container">
          <div class="alert alert--danger" ng-if="\$ctrl.displayEmptyReceiptMessage">
            <span>User has no available invoice</span>
          </div>
        </div>
      </td>
    </tr>
    <tr ng-if="\$ctrl.valueDateEnabled && \$ctrl.loan">
      <td>&nbsp;</td>
      <td>Value Date:</td>
      <td>
        <value-date ng-model="\$ctrl.paymentRequest.valueDate"
                    max="\$ctrl.branchSystemDate | nxDate">
        </value-date>
      </td>
    </tr>
    <tr>
      <td>&nbsp;</td>
      <td>Remarks:</td>
      <td>
        <input type="text"
               maxlength="255"
               ng-model="\$ctrl.paymentRequest.remarks"
               ng-required="\$ctrl.cfg.required('loan', 'payment', 'remarks')">
      </td>
    </tr>
    <tr ng-if="!\$ctrl.customPayment && \$ctrl.advancePayment && \$ctrl.loan.loanType.advancePaymentStrategy == 'USER_SELECT'">
      <td>&nbsp;</td>
      <td>Allocate excess amount:</td>
      <td>
        <select ng-model="\$ctrl.paymentRequest.selectedAdvancePaymentStrategy"
                ng-options="a.value as a.label for a in \$ctrl.availableAdvancePaymentStrategies"
                ng-disabled="\$ctrl.loan.loanType.advancePaymentStrategy !== 'USER_SELECT'"
                ng-change="\$ctrl.onPaymentStrategyChange()"
                required>
        </select>
      </td>
    </tr>
    <tr ng-if="!\$ctrl.customPayment && \$ctrl.advancePayment && \$ctrl.paymentRequest.selectedAdvancePaymentStrategy === 'TRANSFER_TO_CBU'">
      <td>&nbsp;</td>
      <td>CBU Account</td>
      <td>
        <input type="text"
               ng-model="\$ctrl.cbuAccountDetails"
               disabled>
      </td>
      <tr ng-if="!\$ctrl.customPayment && \$ctrl.advancePayment && \$ctrl.paymentRequest.selectedAdvancePaymentStrategy === 'TRANSFER_TO_LINKED_ACCOUNT'">
        <td>&nbsp;</td>
        <td>Linked deposit Account</td>
        <td>
          <input type="text"
                 ng-model="\$ctrl.linkedDepositAccountDetails"
                 disabled>
        </td>
      </tr>

    </tbody>
  </table>

  <div class="alert alert--danger" ng-if="\$ctrl.paymentRequest.amount === undefined">
    Invalid amount provided
  </div>

  <div class="alert alert--danger" ng-if="\$ctrl.error">
    <span><strong>Error!</strong> {{\$ctrl.error}}</span>
    <input ng-show="false" ng-validate="!\$ctrl.error"/>
  </div>

  <div class="alert alert--danger" ng-if="\$ctrl.warning">
    {{\$ctrl.warning}}
  </div>

  <div class="alert" ng-if="\$ctrl.isPDCConflict()">
    There are PDCs issued to one or more amortizations marked for payment. These PDCs will be automatically cancelled.
  </div>

  <table class="table"
         ng-if="!\$ctrl.customPayment && \$ctrl.modifiedAmortizations">
    <thead>
    <tr ng-if="\$ctrl.modifiedAmortizations.length > 0">
      <th>No.</th>
      <th>Status</th>
      <th>Principal</th>
      <th>Interest</th>
      <th ng-if="\$ctrl.showColumn('cbuChargeBalance_initial')">CBU</th>
      <th ng-if="\$ctrl.showColumn('pfChargeBalance_initial')">PF</th>
      <th ng-if="\$ctrl.showColumn('tpChargeBalance_initial')">TP</th>
      <th ng-if="\$ctrl.showColumn('totalPastDueInterestBalance_initial')">Past-due Interest</th>
      <th ng-if="\$ctrl.showColumn('totalPenaltyBalance_initial')">Penalties</th>
      <th ng-if="\$ctrl.showColumn('customFeesBalance_initial')">Custom Fees</th>
      <th>Total</th>
    </tr>
    <tr ng-if="\$ctrl.modifiedAmortizations.length == 0">
      <th colspan="{{\$ctrl.visibleColumns() - 2}}"></th>
      <th>Total</th>
    </tr>
    </thead>
    <tbody ng-repeat="a in \$ctrl.modifiedAmortizations | orderBy:'lineNumber'">
    <tr class="initial-row">
      <td>{{a.lineNumber}}.</td>
      <td class="status-col" ng-class="{'red': a.status_initial === 'OVERDUE'}">{{a.status_initial}}</td>
      <td><input type="text" disabled ng-currency currency-symbol
                 ng-model="a.principalBalance_initial"></td>
      <td><input type="text" disabled ng-currency currency-symbol
                 ng-model="a.interestBalance_initial"></td>
      <td ng-if="\$ctrl.showColumn('cbuChargeBalance_initial')">
        <input type="text" disabled ng-currency currency-symbol
               ng-model="a.cbuChargeBalance_initial">
      </td>
      <td ng-if="\$ctrl.showColumn('pfChargeBalance_initial')">
        <input type="text" disabled ng-currency currency-symbol
               ng-model="a.pfChargeBalance_initial">
      </td>
      <td ng-if="\$ctrl.showColumn('tpChargeBalance_initial')">
        <input type="text" disabled ng-currency currency-symbol
               ng-model="a.tpChargeBalance_initial">
      </td>
      <td ng-if="\$ctrl.showColumn('totalPastDueInterestBalance_initial')">
        <input type="text" disabled ng-currency currency-symbol
               ng-model="a.totalPastDueInterestBalance_initial">
      </td>
      <td class="penalties-column" ng-if="\$ctrl.showColumn('totalPenaltyBalance_initial')">
        <input type="text" disabled ng-currency currency-symbol
               ng-model="a.totalPenaltyBalance_initial">
      </td>
      <td ng-if="\$ctrl.showColumn('customFeesBalance_initial')">
        <input type="text" disabled ng-currency currency-symbol
               ng-model="a.customFeesBalance_initial">
      </td>
      <td class="paid-column">
        <input type="text" disabled ng-currency currency-symbol
               ng-model="a.amortizationBalance_initial">
      </td>
    </tr>
    <tr class="paid-row">
      <td>&nbsp;</td>
      <td class="status-col" ng-class="{'red': a.status === 'OVERDUE', 'green': a.status === 'PAID'}">{{a.status}}</td>
      <td><input type="text" ng-class="a.class['principalBalance']" disabled
                 ng-currency currency-symbol
                 ng-model="a.principalBalance_paid"></td>
      <td><input type="text" ng-class="a.class['interestBalance']" disabled
                 ng-currency currency-symbol
                 ng-model="a.interestBalance_paid"></td>
      <td ng-if="\$ctrl.showColumn('cbuChargeBalance_initial')">
        <input type="text" ng-class="a.class['cbuChargeBalance']" disabled
               ng-currency currency-symbol
                 ng-model="a.cbuChargeBalance_paid">
      </td>
      <td ng-if="\$ctrl.showColumn('pfChargeBalance_initial')">
        <input type="text" ng-class="a.class['pfChargeBalance']" disabled
               ng-currency currency-symbol
                 ng-model="a.pfChargeBalance_paid">
      </td>
      <td ng-if="\$ctrl.showColumn('tpChargeBalance_initial')">
        <input type="text" ng-class="a.class['tpChargeBalance']" disabled
               ng-currency currency-symbol
                 ng-model="a.tpChargeBalance_paid">
      </td>
      <td ng-if="\$ctrl.showColumn('totalPastDueInterestBalance_initial')">
        <input type="text" ng-class="a.class['totalPastDueInterestBalance']" disabled
               ng-currency currency-symbol
                 ng-model="a.totalPastDueInterestBalance_paid">
      </td>
      <td class="penalties-column" ng-if="\$ctrl.showColumn('totalPenaltyBalance_initial')">
        <input type="text" ng-class="a.class['totalPenaltyBalance']"
               disabled
               ng-currency currency-symbol
               ng-model="a.totalPenaltyBalance_paid"/>
      </td>
      <td ng-if="\$ctrl.showColumn('customFeesBalance_initial')">
        <input type="text" ng-class="a.class['customFeesBalance']"
                 disabled
               ng-currency currency-symbol
                 ng-model="a.customFeesBalance_paid"/>
      </td>
      <td class="paid-column">
        <input type="text" ng-class="a.class['amortizationBalance']" disabled
               ng-currency currency-symbol ng-model="a.paid"></td>
    </tr>
    </tbody>
    <tr ng-if="\$ctrl.excessNonHierarchyPayment > 0">
      <td colspan="{{\$ctrl.visibleColumns() - 3}}" class="transparent"></td>
      <td>
        {{\$ctrl.paymentRequest.selectedAdvancePaymentStrategy == 'TRANSFER_TO_CBU' ? 'Excess CBU payment' : 'Excess linked deposit account payment'}}
      </td>
      <td class="paid-column">
        <input type="text" class="paid" disabled
               ng-currency currency-symbol ng-model="\$ctrl.excessNonHierarchyPayment"/>
      </td>
    </tr>
    <tbody>
    <tr>
      <td colspan="{{\$ctrl.visibleColumns() - 2}}" class="transparent"></td>
      <td class="paid-column">
        <input type="text" class="paid" disabled ng-currency currency-symbol ng-model="\$ctrl.totalPaidAmount">
      </td>
    </tr>
    </tbody>
  </table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/common/amortization-payment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;